var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth',[_c('h2',[_vm._v("Access Denied")]),_c('el-button',{on:{"click":function($event){return _vm.$router.push({ name: 'home' })}}},[_vm._v(" Home ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }